import { render, staticRenderFns } from "./TextBoxComponent.vue?vue&type=template&id=a33def7a"
import script from "./TextBoxComponent.vue?vue&type=script&lang=js"
export * from "./TextBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports